import React, { Component } from 'react';
import {
    Tabs
} from './LabelStyle';

class Label extends Component {

    state = {
        activeKey: '0'
    }
    handleClick = (id) => {
        this.setState({
            activeKey: id
        })
        this.props.cb && this.props.cb(id, null, null);
        //返回顶部
        //window.scrollTo( 0, 0 );
    }
    render() {
        return (
            <Tabs>
                <div className={this.state.activeKey === '0' ? 'selected' : ''} onClick={this.handleClick.bind(this, '0')}>
                    <span>体验店</span>
                    {
                        this.state.activeKey === '0' ? <div /> : ''
                    }
                </div>
                <div className={this.state.activeKey === '1' ? 'selected' : ''} onClick={this.handleClick.bind(this, '1')}>
                    <span>线上店</span>
                    {
                        this.state.activeKey === '1' ? <div /> : ''
                    }
                </div>
            </Tabs>
        )
    }
}

export default Label;
